module.exports = __webpack_public_path__ + "img/b5-4.4c2b2d6.png";